(function(){
  var root=document.getElementById('ltr'); if(!root) return;
  var $=function(s,c){return (c||root).querySelector(s)}, $$=function(s,c){return Array.prototype.slice.call((c||root).querySelectorAll(s))};

  /* ---- ticker: duplicate content for seamless loop ---- */
  var tk=$('#ltrTicker'); if(tk){ tk.innerHTML=tk.innerHTML+tk.innerHTML+tk.innerHTML; }
  $$('[data-clone="ltrTicker"]').forEach(function(t){ t.innerHTML=tk.innerHTML; });

  /* ---- arrives-by date (1 business day handling + 4 transit days, skip Sunday) ---- */
  (function(){
    var d=new Date(); var add=5; if(d.getDay()===6) add+=1; if(d.getDay()===0) add+=1;
    d.setDate(d.getDate()+add); if(d.getDay()===0) d.setDate(d.getDate()+1);
    var s=d.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'});
    $$('#arriveBy, .arriveBy').forEach(function(e){e.textContent=s;});
  })();

  /* ---- gallery ---- */
  var gm=$('#galMain'), thumbs=$$('#galThumbs button'), dots=$$('#galDots i'), imgs=$$('#galMain img');
  function showImg(i){
    if(window.innerWidth<=640){ gm.scrollTo({left:gm.clientWidth*i,behavior:'smooth'}); }
    else { imgs.forEach(function(im,k){ im.style.display=(k===i?'block':'none'); }); }
    thumbs.forEach(function(b,k){b.classList.toggle('on',k===i)}); dots.forEach(function(b,k){b.classList.toggle('on',k===i)});
  }
  thumbs.forEach(function(b,i){ b.addEventListener('click',function(){showImg(i)}); });
  function layoutGal(){ if(window.innerWidth<=640){ imgs.forEach(function(im){im.style.display='block'}); } else { showImg(thumbs.findIndex(function(b){return b.classList.contains('on')})||0); } }
  layoutGal(); window.addEventListener('resize',layoutGal);
  gm.addEventListener('scroll',function(){ if(window.innerWidth>640) return; var i=Math.round(gm.scrollLeft/gm.clientWidth); dots.forEach(function(b,k){b.classList.toggle('on',k===i)}); });

  /* ---- CUSTOMER SELFIES: paste CDN URLs here, one per line. First 14 feed the photo strip above the review cards, first 24 feed the selfie wall. Leave empty and both hide. ---- */
  var UGC = [
    'https://cdn.shopify.com/s/files/1/2292/4453/files/Bill_R.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/Amy_M.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/Tom_H.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/Martha_S.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/tincture_selfie_2.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/Karen_T.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/Brian_T.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/Megan_T.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/tincture_selfie_7.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/w1.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/James_R.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/tincture_selfie_10.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/m6.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/Laura_K.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/tincture_selfie_4.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/tincture_selfie_8.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/tincture_selfie_9.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/w6.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/Christine_W.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/tincture_selfie_6.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/Pauline.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/m2.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/tincture_selfie_5.png?width=600',
    'https://cdn.shopify.com/s/files/1/2292/4453/files/tincture_selfie_1.png?width=600'
  ];
  (function(){
    var strip=$('#ugcStrip'), grid=$('#wallGrid'), sec=$('#wallSec');
    if(!UGC.length){ if(strip) strip.style.display='none'; if(sec) sec.style.display='none'; return; }
    if(strip){ UGC.slice(0,14).forEach(function(u){ var d=document.createElement('div'); d.innerHTML='<img src="'+u.replace('width=600','width=300')+'" alt="Lifetones customer" loading="lazy">'; strip.appendChild(d); }); }
    if(grid){ UGC.slice(0,24).forEach(function(u){ var d=document.createElement('div'); d.className='wall-tile'; d.innerHTML='<img src="'+u+'" alt="Lifetones customer" loading="lazy">'; grid.appendChild(d); }); }
  })();

  /* ---- Zipify containment: break out to full viewport width ---- */
  (function(){
    function bleed(){
      root.style.left='0'; root.style.width='auto'; root.style.maxWidth='none'; root.style.marginLeft='0'; root.style.marginTop='';
      var cw=document.documentElement.clientWidth, r=root.getBoundingClientRect();
      root.style.width=cw+'px'; root.style.marginLeft=(-r.left)+'px';
      var top=r.top+window.scrollY; if(top>0 && top<80 && window.scrollY===0) root.style.marginTop=(-top)+'px';
    }
    bleed(); window.addEventListener('resize',bleed); window.addEventListener('load',bleed);
  })();

  /* ---- mobile: move the video trio below the buy box so the headline and price stay near the fold ---- */
  (function(){
    var ugc=$('.ugc-under'), galCol=ugc&&ugc.parentNode, buyCol=$('.hero-grid>div:nth-child(2)');
    if(!ugc||!buyCol) return;
    function place(){ if(window.innerWidth<=640){ if(ugc.parentNode!==buyCol) buyCol.appendChild(ugc); } else { if(ugc.parentNode!==galCol) galCol.appendChild(ugc); } }
    place(); window.addEventListener('resize',place);
  })();

  /* ---- accordions ---- */
  $$('.acc-item>button').forEach(function(b){ b.addEventListener('click',function(){ b.parentNode.classList.toggle('open'); }); });
  $$('.bcard').forEach(function(c){ c.addEventListener('click',function(){ c.classList.toggle('open'); }); });

  /* ---- videos: tiles open a lightbox that plays at native aspect ---- */
  var lb=$('#vlb'), lbv=$('#vlbVideo'), lbc=$('#vlbCap');
  function openLb(src, fallback, ratio, label){
    lbv.style.aspectRatio=ratio||'16/9'; lbv.onerror=null; lbv.src=src; lbc.textContent=label||'';
    if(fallback){ lbv.onerror=function(){ lbv.onerror=null; lbv.src=fallback; lbv.play().catch(function(){}); }; }
    lb.classList.add('ltr-open'); lb.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden';
    $$('.vprev',root).forEach(function(v){ v.pause(); });
    lbv.play().catch(function(){});
  }
  function closeLb(){ lbv.pause(); lbv.removeAttribute('src'); lbv.load(); lb.classList.remove('ltr-open'); lb.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; $$('.vprev',root).forEach(function(v){ v.play().catch(function(){}); }); }
  $$('.vid[data-video]').forEach(function(v){ v.addEventListener('click',function(){ openLb(v.getAttribute('data-video'), v.getAttribute('data-fallback'), v.getAttribute('data-ratio'), v.getAttribute('data-label')); }); });
  $('.vlb-bg',lb).addEventListener('click',closeLb); $('.vlb-x',lb).addEventListener('click',closeLb);
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && lb.classList.contains('ltr-open')) closeLb(); });
  /* poster fallback for the preview tile if the poster JPG is not uploaded yet */
  /* preview tiles only download when scrolled into view (saves ~2.7 MB on first paint) */
  (function(){
    var tiles=$$('.vprev',root); if(!tiles.length) return;
    var conn=navigator.connection||{}; if(conn.saveData) return;
    function start(v){ if(v.src) return; v.src=v.getAttribute('data-src'); v.play().catch(function(){}); }
    if(!('IntersectionObserver' in window)){ tiles.forEach(start); return; }
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ start(e.target); io.unobserve(e.target); } }); },{rootMargin:'200px'});
    tiles.forEach(function(v){ io.observe(v); });
  })();

  /* ---- carousels ---- */
  function step(track,dir){ var first=track.children[0]; var w=first? first.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||18):300; track.scrollBy({left:dir*w,behavior:'smooth'}); }
  $$('[data-prev]').forEach(function(b){ b.addEventListener('click',function(){ step($('#'+b.getAttribute('data-prev')),-1); }); });
  $$('[data-next]').forEach(function(b){ b.addEventListener('click',function(){ step($('#'+b.getAttribute('data-next')),1); }); });
  $$('[data-dots]').forEach(function(d){
    var track=$('#'+d.getAttribute('data-dots')); var n=track.children.length; d.innerHTML=''; for(var i=0;i<n;i++){ d.appendChild(document.createElement('i')); }
    function upd(){ var first=track.children[0]; var w=first.getBoundingClientRect().width+18; var i=Math.round(track.scrollLeft/w); $$('i',d).forEach(function(x,k){x.classList.toggle('on',k===i)}); }
    track.addEventListener('scroll',upd); upd();
  });

  /* ---- bundle picker (hero + cloned stock-up box share state) ---- */
  var CART='/cart/';
  var boxes=[ $('#bundles').parentNode ];
  var bb2=$('#buybox2');
  if(bb2){
    var src=$('#bundles').parentNode;
    ['.giftbar','.pricerow','#bundles','#ladder','.ship','#atcBtn','.trust'].forEach(function(sel){
      var n=$(sel,src).cloneNode(true); n.removeAttribute('id'); $$('[id]',n).forEach(function(x){x.removeAttribute('id')}); bb2.appendChild(n);
    });
    $('.arriveBy',bb2); var ab=$('.ship b',bb2); if(ab){ ab.className='arriveBy'; ab.textContent=$('#arriveBy').textContent; }
    boxes.push(bb2);
  }
  function fmt(n){ return '$'+Number(n).toFixed(2); }
  var curQty=1;
  function select(opt){
    var v=opt.getAttribute('data-variant'), price=+opt.getAttribute('data-price'), cmp=+opt.getAttribute('data-compare'), qty=+opt.getAttribute('data-qty'), ship=opt.getAttribute('data-ship');
    curQty=qty;
    boxes.forEach(function(box){
      $$('.bopt',box).forEach(function(o){ o.classList.toggle('on', o.getAttribute('data-variant')===v); });
      var now=$('.pricerow .pr-now',box), was=$('.pricerow .pr-was',box), tag=$('.pricerow .pr-tag',box);
      if(now) now.textContent=fmt(price); if(was) was.textContent=fmt(cmp);
      if(tag) tag.innerHTML=(qty===1?'FREE GIFT':'FREE GIFT + SHIPPING')+' &ndash; Save '+fmt(cmp-price);
      var atc=$('.atc',box); if(atc){ atc.href=CART+v+':1'; $('.atc-pr s',atc).textContent=fmt(cmp); $('.atc-pr span',atc).textContent=fmt(price); }
      $$('.ladder .ld-item',box).forEach(function(it){ var tier=+it.getAttribute('data-tier'); it.classList.toggle('locked', qty<tier); });
      var fill=$('.gb-fill',box), txt=$('.giftbar span',box);
      if(fill) fill.style.width=(qty===1?'50%':'100%');
      if(txt) txt.textContent=(qty===1?'Free massager unlocked. Free shipping at 3+':'Free massager + free shipping unlocked');
    });
    var st=$('#stBtn'); if(st) st.href=CART+v+':1'; var sn=$('#stNow'); if(sn) sn.textContent=fmt(price); var sw=$('#stWas'); if(sw) sw.textContent=fmt(cmp);
  }
  var BIMG='https://cdn.shopify.com/s/files/1/2292/4453/files/';
  function swapHero(opt){ var k=opt.getAttribute('data-img'); if(!k||!imgs[0]) return; var src=BIMG+k+'.webp?width=900'; if(imgs[0].getAttribute('src')===src) return; imgs[0].src=src; var t=thumbs[0]&&thumbs[0].querySelector('img'); if(t) t.src=BIMG+k+'.webp?width=200'; showImg(0); }
  boxes.forEach(function(box){ $$('.bopt',box).forEach(function(o){ o.addEventListener('click',function(){ select(o); swapHero(o); }); }); });
  select($('#bundles .bopt.on'));

  /* ---- 2-pack upsell modal: fires once per session when the single bottle is added to cart ---- */
  (function(){
    var ups=$('#ups'); if(!ups) return;
    var pendingHref='', shown=false;
    try{ shown=sessionStorage.getItem('ltr_ups')==='1'; }catch(e){}
    function openUps(href){ pendingHref=href; ups.classList.add('ltr-open'); ups.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; shown=true; try{ sessionStorage.setItem('ltr_ups','1'); }catch(e){} }
    function declineUps(){ ups.classList.remove('ltr-open'); ups.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; if(pendingHref) window.location.href=pendingHref; }
    function onAtc(e){ if(curQty!==1||shown) return; e.preventDefault(); openUps(this.getAttribute('href')); }
    $$('.atc, #stBtn').forEach(function(a){ a.addEventListener('click',onAtc); });
    $('#upsNo').addEventListener('click',declineUps); $('.ups-x',ups).addEventListener('click',declineUps); $('.ups-bg',ups).addEventListener('click',declineUps);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape' && ups.classList.contains('ltr-open')) declineUps(); });
  })();

  /* ---- sticky mobile bar ---- */
  var sticky=$('#sticky'), hero=$('.hero');
  var heroAtc=$('#atcBtn');
  function onScroll(){ if(!sticky||!heroAtc) return; var r=heroAtc.getBoundingClientRect(); var off=(r.bottom<0)||(r.top>window.innerHeight); sticky.classList.toggle('ltr-show', off && window.scrollY>240); }
  window.addEventListener('scroll',onScroll,{passive:true}); onScroll();

  /* ---- smooth anchor to top buy box ---- */
  $$('a[href="#ltr"]').forEach(function(a){ a.addEventListener('click',function(e){ e.preventDefault(); $('#bundles').scrollIntoView({behavior:'smooth',block:'center'}); }); });
})();
